module.exports = __webpack_public_path__ + "media/images/idea_guy-219dc8dd48dea6d076410320c1310291.svg";